import React from 'react'
import './styles.less'

type Props = {
    label:string
    onChange:(e:React.ChangeEvent<HTMLInputElement>)=>void
    name:string
    id:string
    defaultChecked:boolean
}

const ToggleInput = (props: Props) => {
  return (
    <div className='toggleInput'>
        <p>{props.label}</p>
        <label className='toggleInput__switch'>
            <input type="checkbox" onChange={props.onChange} name={props.name} id={props.id} checked={props.defaultChecked}/>
            <span className="toggleInput__sliderRound"></span>
        </label>

    </div>
  )
}

export default ToggleInput